<!--
 * @Author: Latte
 * @Date: 2021-09-10 09:12:58
 * @LAstEditors: Latte
 * @LastEditTime: 2022-01-17 15:39:14
 * @FilePath: \Siui.Cloud.Medical.Web\src\components\FileManagement\User\userRecord.vue
-->
<template>
  <div class="app-container">
    <div>
      <el-form
              :model="listQuery"
              size="small"
              :inline="true"
      >
        <el-row>
          <el-col :span="18">
            <el-input
                    v-model="listQuery.keyWord"
                    placeholder="输入关键词搜索，支持：用户昵称 / 文件名称  "
                    clearable
                    @keyup.native.enter="onChangeProperty"
            ><i slot="prefix" class="el-input__icon el-icon-search"></i></el-input>
          </el-col>
          <el-col :span="6">
            <el-button type="primary" size="small" style="margin-left: 10px;border-radius: 2px"  @click=" getUserRecordList">
              {{ $t("search") }}
            </el-button>
            <el-dropdown style="margin-left: 5px;border-radius: 2px;margin-top: 3px" @command="handleCommand">
              <el-button size="small">
                导出Excel<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="a">全部数据</el-dropdown-item>
                <el-dropdown-item command="b">选中数据</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
<!--            <el-button  size="small" style="margin-left: 10px;border-radius: 2px;margin-top: 3px"  @click="exportData">-->
<!--              导出Excel-->
<!--            </el-button>-->
          </el-col>
        </el-row>
      </el-form>
      <!-- 表格 -->
      <el-table
        row-key="csFileViewRecordID"
        v-loading="loading"
        :data="userRecordList"
        ref="multipleTable"
        :header-cell-style="{ background: '#F5F7FA' }"
        style="width: 100%;margin-bottom: 20px;margin-top: 5px"
        stripe
        border
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" :selectable="selectable" :reserve-selection="true" width="40" align="center" />
        <el-table-column
          prop="csFileViewRecordID"
          label="ID"
          align="center"
          width="55"
        >
        </el-table-column>
        <el-table-column prop="nickName" show-overflow-tooltip label="用户名" align="center">
        </el-table-column>
        <el-table-column prop="mobilePhone" label="手机号码" align="center">
        </el-table-column>
        <el-table-column
          label="文件名"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <a style="color: blue">{{ scope.row.fileShowName}}</a>
          </template>
        </el-table-column>
        <el-table-column
                label="文件类型"
                align="center"
                show-overflow-tooltip
                width="50"
        >
          <template slot-scope="scope">
            <a style="color: forestgreen">{{ scope.row.fileSuffix === ".pdf" ? "文档" :scope.row.fileSuffix === ".mp4" ? "视频":scope.row.fileSuffix === ".mp3"?"音频":scope.row.fileSuffix === ".jpg"?"图片":scope.row.fileSuffix === ".png"?"图片":"" }}</a>
          </template>
        </el-table-column>
        <el-table-column label="浏览时间" align="center">
          <template slot-scope="scope">
            {{ scope.row.viewTime | formatDateTime }}
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div v-show="totalCount > pageSize" class="pagination">
        <el-select v-model="pageSize" placeholder="全部产品分类" style="width:15%;float: right" @change="onPageSizeChange">
          <el-option v-for="item in pageSizeOptions" :value="item.fieldValue" :label="item.showName"
                     :key="item.fieldValue" />
        </el-select>
        <el-pagination
          v-show="userRecordList.length > 0"
          background
          layout="prev, pager, next"
          :page-size="pageSize"
          :total="totalCount"
          :current-page="currentPage"
          @current-change="currentChange"
        />
        <p style="color: gray">共{{totalCount}}条</p>
      </div>
    </div>
  </div>
</template>

<script>
import { getUserRecordList } from "@/api/system/CSDocument/user";

export default {
  data() {
    return {
      listQuery:{
        keyWord:""
      },
      loading: false, // 加载开关
      searchUser: "", // 搜索内容
      totalCount: 0, // 总数
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页条数
      userRecordList: [], // 用户记录列表
      exportRecordList:[],
      pageSizeOptions:[{fieldValue:10,showName:"10条/页"},{fieldValue:20,showName:"20条/页"},{fieldValue:50,showName:"50条/页"},{fieldValue:100,showName:"100条/页"}],
      selectTempList:[]
    };
  },
  created() {
    this.getUserRecordList();
    this.$refs.multipleTable.clearSelection();
  },
  methods: {

    /**
     * 不同模式导出excel数据
     */
    handleCommand(command) {
      if("a"===command){
        this.exportData();
      }
      else if("b"===command){
        if(this.$refs.multipleTable.selection.length===0){
          this.$notify.error({
            title: '错误',
            message: '请选择数据'
          });
        }
        else{
          this.selectTempList=this.$refs.multipleTable.selection;
          try{
            this.exportList(this.selectTempList);
            this.$refs.multipleTable.clearSelection();
          }
          catch (e) {
            
          }
        }

      }
    },
    //置灰部分选择
    selectable(row, index){
      let isSelected = this.$refs.multipleTable.selection.includes(row);
      return !(this.selectMax > 0 && this.$refs.multipleTable.selection.length >= this.selectMax) || isSelected;
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      if (selection) {
        if (this.selectMax > 0 && selection.length >= this.selectMax){
          // 截取20位后,不需要的数据
          let tempArr = selection.slice(this.selectMax);
          tempArr.forEach((ele) => {
            this.$refs.multipleTable.toggleRowSelection(ele, false);
          });
          // 截取前20位
          selection = selection.slice(0, this.selectMax);
        }
      }
    },

    /**
     * 页面变更
     */
    onPageSizeChange(e){
      this.pageSize=e;
      this.currentPage=1;
      this.getUserRecordList();
    },

    /**
     * 导出条件下的所有数据
     */
    exportData() {
      this.loading = true;
      this.exportRecordList=[];
      let params = {
        sortName: "",
        sortOrder: "",
        pageNumber: 0,
        pageSize: 0,
        keyWord: this.listQuery.keyWord,
        where: "",
      };
      getUserRecordList(params).then((res) => {
        this.exportRecordList = res.data.rows;
        if(this.exportRecordList!==[]){
          this.exportList(this.exportRecordList);
        }
      });
      this.utils.stopLoading(this);
    },

    exportList(exportRecordList){
      if(exportRecordList!==[]){
        require.ensure([], () => {
          const { export_json_to_excel } = require("@/excel/Export2Excel");
          const fieldName = ["记录ID","昵称","用户ID","手机", "浏览文件名","格式","浏览时间"];
          const filterVal = ["csFileViewRecordID","nickName","userID", "mobilePhone", "fileShowName","fileSuffix","viewTime"];
          const data = exportRecordList.map(v => filterVal.map(j => v[j]));
          export_json_to_excel(fieldName, data, this.formatDate('YYMMDDhhmmss')+"VisitorLogs");
          this.$notify({
            title: '导出成功',
            message: '文件下载中，请耐心等待！',
            type: 'success'
          });
        });
      }
    },

    /**
     * 根据输入的日期格式 格式化当前时间，入参如：YYMMDDhhmmss
     */
    formatDate (fmt) {
      const date = new Date();
      const o = {
        'Y+': date.getFullYear(),
        'M+': date.getMonth() + 1, // 月
        'D+': date.getDate(), // 日
        'h+': date.getHours(), // 时
        'm+': date.getMinutes(), // 分
        's+': date.getSeconds(), // 秒
        W: date.getDay() // 周
      };
      for (let k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
          fmt = fmt.replace(RegExp.$1, () => {
            if (k === 'W') {
              // 星期几
              const week = ['日', '一', '二', '三', '四', '五', '六']
              return week[o[k]]
            } else if (k === 'Y+' || RegExp.$1.length === 1) {
              // 年份 or 小于10不加0
              return o[k]
            } else {
              return ('00' + o[k]).substr(('' + o[k]).length) // 小于10补位0
            }
          })
        }
      }
      return fmt
    },

    /**
     * 翻页
     *
     * @param {number} currentPage 当前页码
     */
    currentChange(currentPage) {
      this.currentPage = currentPage;
      this.getUserRecordList();
    },

    /**
     * 搜索栏内容出现变更，执行重新搜索
     */
    onChangeProperty(){
      this.currentPage=1; // 当前页码
      this.pageSize=10; // 每页条数
      this.getUserRecordList();
    },

    /**
     * 获取用户记录列表
     */
    getUserRecordList() {
      let params = {
        sortName: "",
        sortOrder: "",
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
        keyWord: this.listQuery.keyWord,
        where: "",
      };
      this.loading = true;
      getUserRecordList(params).then((res) => {
        this.userRecordList = res.data.rows;
        this.totalCount = res.data.total;
        this.utils.stopLoading(this);
      });
    },
  },
};
</script>

<style scoped lang="scss"></style>
